
import { mapGetters } from 'vuex';
import {
  parseDirectory,
  stateAwareRouteDefinition,
  applyStatetoRoute,
} from '@/support';

export default {
  computed: {
    ...mapGetters(['currentDirectory']),

    crumbs() {
      const segments = parseDirectory(this.currentDirectory.path())
        .split('/')
        .filter(Boolean);

      return segments.reduce((acc, directory) => {
        const crumb = {
          basename: directory,
          path: acc
            .reduceRight((acc2, c) => acc2.concat(c.basename), [directory])
            .concat('')
            .reverse()
            .join('/'),
        };

        return acc.concat(crumb);
      }, []);
    },
  },

  methods: {
    url(path) {
      return applyStatetoRoute(stateAwareRouteDefinition({ path }), {
        sidebar: true,
      });
    },
  },
};
